import { Button, Stack } from "@mui/material";
import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";

export const ListingModalLoading = () => {
  const theme = useSelector((state: RootState) => state.theme);
  return (
    <Stack
      sx={{
        backgroundColor: theme.componentColors.surface.surfContainerHigh,
      }}
      className="animate-pulse rounded-2xl py-[24px] px-[10px] p-5"
    >
      <Stack
        sx={{
          backgroundColor: theme.componentColors.surface.surfContainer,
        }}
        className="w-[100px] h-[10px] rounded-2xl "
      />
      <Stack
        sx={{
          backgroundColor: theme.componentColors.surface.surfContainer,
        }}
        className="w-[150px] h-[10px] rounded-2xl mt-[5px]"
      />

      <Stack
        sx={{
          borderBottom: "1px solid",
          borderColor: theme.componentColors.surface.surfContainer,
        }}
        direction="row"
        className="flex items-center space-x-[20px] w-full justify-between py-[16px]"
      >
        <Stack className="space-y-[5px]">
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[200px] h-[10px]"
          />
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[50px] h-[20px]"
          />
        </Stack>
        <Button
          className="w-[82px] h-[37px]"
          sx={{
            backgroundColor: theme.componentColors.surface.surfContainer,
          }}
        ></Button>
      </Stack>

      <Stack
        sx={{
          borderBottom: "1px solid",
          borderColor: theme.componentColors.surface.surfContainer,
        }}
        direction="row"
        className="flex items-center space-x-[20px] w-full justify-between py-[16px]"
      >
        <Stack className="space-y-[5px]">
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[200px] h-[10px]"
          />
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[50px] h-[20px]"
          />
        </Stack>
        <Button
          className="w-[82px] h-[37px]"
          sx={{
            backgroundColor: theme.componentColors.surface.surfContainer,
          }}
        ></Button>
      </Stack>

      <Stack
        sx={{
          borderBottom: "1px solid",
          borderColor: theme.componentColors.surface.surfContainer,
        }}
        direction="row"
        className="flex items-center space-x-[20px] w-full justify-between py-[16px]"
      >
        <Stack className="space-y-[5px]">
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[200px] h-[10px]"
          />
          <Stack
            sx={{
              backgroundColor: theme.componentColors.surface.surfContainer,
            }}
            className="w-[50px] h-[20px]"
          />
        </Stack>
        <Button
          className="w-[82px] h-[37px]"
          sx={{
            backgroundColor: theme.componentColors.surface.surfContainer,
          }}
        ></Button>
      </Stack>

      <Stack
        sx={{
          backgroundColor: theme.componentColors.surface.surfContainer,
        }}
        className="w-[200px] h-[15px] rounded-2xl mt-[16px]"
      />
    </Stack>
  );
};
